import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/classDuration'
import {combineEpics} from 'redux-observable'

export const classDurationEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)